import { Dispatch, SetStateAction } from 'react';
import { MUSINSA_S1_MAP_ID } from 'constants/musinsa';
import useColorSetStore from 'stores/colorSet';
import useDomainStore from 'stores/domain';
import useMachineStore from 'stores/machine';
import useWebInfoStore from 'stores/webInfo';
import { SearchTabType } from 'types/feature/tenantFilter.type';
import styles from './TenantFilter.module.scss';
import CategoryController from './controller/category/CategoryController';
import FloorController from './controller/floor/FloorController';
import KeypadController from './controller/keypad/KeypadController';
import SearchTabs from './tab/SearchTabs';

type Props = {
  currentFilter: SearchTabType;
  setCurrentFilter: Dispatch<SetStateAction<SearchTabType>>;
};

const TenantFilter = ({ currentFilter, setCurrentFilter }: Props) => {
  // store
  const colorSetStore = useColorSetStore();
  const webInfoStore = useWebInfoStore();
  const machineStore = useMachineStore();
  const domainStore = useDomainStore();

  const mapId = domainStore.isRealWeb() ? webInfoStore.webInfo?.map.id : machineStore.machine?.map.id;
  const isMusinsaS1Map = mapId === MUSINSA_S1_MAP_ID;
  const containerClassName = isMusinsaS1Map ? `${styles.container} ${styles.musinsa_s1}` : styles.container;

  return (
    <div style={{ background: colorSetStore.header.bg }} className={containerClassName}>
      {/* 포인트 선택, 필터 탭 */}
      <SearchTabs currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />

      {/* 초성 검색, 층별 검색, 카테고리 검색 */}
      {currentFilter === SearchTabType.tenant && <KeypadController />}
      {currentFilter === SearchTabType.floor && <FloorController />}
      {currentFilter === SearchTabType.category && <CategoryController currentFilter={currentFilter} />}
    </div>
  );
};
export default TenantFilter;
